mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
    email
    phone
    firstName
    lastName
    middleName
    displayName
    avatar {
      id
      url(format: SMALL)
    }
    isAdmin
    createdAt
    updatedAt
  }
}
